/**
 * A small amber line saying a review did not check everything it was asked
 * to — e.g. "Couldn't check: Compliance. Run again." Shown in place of (or
 * above) the issue list so a partial check never reads as a clean one.
 *
 * Shared by the editor's Review tab, the reader's Checks tab, and the analysis
 * tables (an extraction that could not read the AI's whole answer).
 */

import { AlertCircle } from 'lucide-react'

export function ReviewRunNotice({ message }: { message: string }) {
  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-lg border border-[hsl(var(--status-warning)/0.3)] bg-[hsl(var(--status-warning)/0.1)] px-2 py-1.5 text-left text-xs text-foreground"
    >
      <AlertCircle className="mt-px h-3.5 w-3.5 shrink-0 text-[hsl(var(--status-warning))]" aria-hidden />
      <span className="min-w-0 flex-1">{message}</span>
    </div>
  )
}
